import axios, {InternalAxiosRequestConfig} from "axios";
import {addRequestIdToQuery} from "@bounce/shared/requests";

export const axiosReachInstance = axios.create({
  baseURL: import.meta.env.VITE_REACH_API_URL,
});

axiosReachInstance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (!config.headers.Authorization) {
    const agentToken = localStorage.getItem("agentToken");
    if (agentToken) {
      config.headers.Authorization = `Bearer ${agentToken}`;
    }
  }
  return config;
});

addRequestIdToQuery(axiosReachInstance);
